import { TRevenueSnapshotKeys } from 'legacy/lut/classes/models/partner360/ELT/IELTFinancialData'

export const notVisibleKeys: TRevenueSnapshotKeys[] = [
  'Revenue3D',
  //supplies
  'RevenueSuppliesSouthMiddleEuropeAndAfrica',
  'RevenueSuppliesCentralEastEurope',
  'RevenueSuppliesNorthEurope',
  'RevenueSuppliesAsia',
  'RevenueSuppliesIndiaAndBSL',
  'RevenueSuppliesChina',
  'RevenueSuppliesLatinAmerica',
  'RevenueSuppliesNorthAmerica',
  'SuppliesByMarketsTotal',
  //poly
  'PolyByMarketsTotal',
  'RevenuePolySouthMiddleEuropeAndAfrica',
  'RevenuePolyCentralEastEurope',
  'RevenuePolyNorthEurope',
  'RevenuePolyAsia',
  'RevenuePolyIndiaAndBSL',
  'RevenuePolyChina',
  'RevenuePolyLatinAmerica',
  'RevenuePolyNorthAmerica',
]

export const keyField = 'Key'
